import FacebookShareBtn from './FacebookShareBtn';
import TwitterShareBtn from './TwitterShareBtn';
import PinterestShareBtn from './PinterestShareBtn';
import LinkedinShareBtn from './LinkedinShareBtn';
import EmailShareBtn from './EmailShareBtn';
import CopyShareBtn from './CopyShareBtn';

customElements.define('facebook-share', FacebookShareBtn);
customElements.define('twitter-share', TwitterShareBtn);
customElements.define('pinterest-share', PinterestShareBtn);
customElements.define('linkedin-share', LinkedinShareBtn);
customElements.define('email-share', EmailShareBtn);
customElements.define('copy-share', CopyShareBtn);
